import React from 'react';
import { Columns3, Check, Lock } from 'lucide-react';
import { Tooltip } from '../ui/Tooltip';
const assessedMarkets = ['AU', 'SG'];
const lockedMarkets = ['US'];
const lockedTooltip = 'No assessment yet — create a dossier for this market to compare';
interface CompareControlsProps {
  onCompare: () => void;
  onLockedMarket: () => void;
}
export function CompareControls({
  onCompare,
  onLockedMarket
}: CompareControlsProps) {
  return <div className="flex flex-wrap items-center gap-3 border-b border-[#e5ebe3] bg-white px-4 py-2.5" data-id="element-108" data-mp="1i5i7rh2tqoy9">
      <button type="button" onClick={onCompare} className="inline-flex items-center gap-2 rounded-lg border border-[#d6dfd3] bg-white px-3 py-1.5 text-sm font-semibold text-evergreen transition hover:bg-[#f7faf5] focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-green" data-id="element-109" data-mp="1m5sc6payx7b0">
        <Columns3 className="h-4 w-4" data-id="element-110" data-mp="211zwrqqagaqt" />
        Compare
      </button>
      <div className="flex flex-wrap items-center gap-1.5" aria-label="Market assessment status" data-id="element-111" data-mp="25w44ic7domsy">
        {assessedMarkets.map(market => <span key={market} className="inline-flex items-center gap-1 rounded-full border border-forest-green/45 bg-white px-2.5 py-1 font-mono text-[11px] font-semibold text-forest-green" data-id="element-112" data-mp="1gp8253fnooj4">
            <Check className="h-3 w-3" data-id="element-113" data-mp="1ppo428gr3nlv" />
            {market}
          </span>)}
        {lockedMarkets.map(market => <Tooltip key={market} content={lockedTooltip} data-id="element-114" data-mp="24d9bgekns8zl">
            <button type="button" onClick={onLockedMarket} className="inline-flex items-center gap-1 rounded-full border border-dashed border-[#c3ccc4] bg-[#f7f8f6] px-2.5 py-1 font-mono text-[11px] font-semibold text-[#8b968d] transition hover:bg-[#f1f3f0]" data-id="element-115" data-mp="1zg931x0c6u5b">
              <Lock className="h-3 w-3" data-id="element-116" data-mp="j2iuoe26pjpv" />
              {market}
            </button>
          </Tooltip>)}
      </div>
    </div>;
}
interface CompareGateProps {
  onAddMarket: () => void;
}
export function CompareGate({
  onAddMarket
}: CompareGateProps) {
  return <section className="mx-auto max-w-lg rounded-2xl border border-[#dce3da] bg-white px-6 py-10 text-center shadow-sm" aria-labelledby="compare-gate-heading" data-id="element-117" data-mp="2j37c2hmd8ddl">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#eff3ed] text-forest-green" data-id="element-118" data-mp="2o4woo1p8kz3s">
        <Columns3 className="h-6 w-6" data-id="element-119" data-mp="2x3i59rb5e41x" />
      </span>
      <h2 id="compare-gate-heading" className="mt-5 font-[Figtree] text-xl font-semibold text-evergreen" data-id="element-120" data-mp="2x2p6pdmcekuv">
        Compare needs at least two assessed markets
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-[#687a6d]" data-id="element-121" data-mp="36sryjahq9srm">
        This product has been assessed for Australia only. Create an assessment for another market to compare results side by side.
      </p>
      <button type="button" onClick={onAddMarket} className="mt-6 inline-flex items-center justify-center rounded-xl bg-evergreen px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-forest-green focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-green focus-visible:ring-offset-2" data-id="element-122" data-mp="3furfk2sqswuk">
        Add a market
      </button>
    </section>;
}